<template>
  <div class="col-12 col-lg-6 c g">
    <br>
    <div class="card">
        <div class="card-body">
            <div style='width: 100%;'>
                <div style='width: 32%; text-align: center; display: inline-block; vertical-align: middle;'>
                    <h5>
                        المملكة العربية السعودية
                        <br>
                        {{ ask.ministry_name || ministry_name }}
                        <br>
                        {{ ask.school_name || '' }}
                    </h5>
                </div>
                <div style='width: 32%; text-align: center; display: inline-block; vertical-align: middle;'>
                    <img style="width: 120px;" :src="ask.ministry_logo || ministry_logo">
                </div>
                <div style='width: 32%; text-align: center; display: inline-block; vertical-align: middle;'>
                    <h5 v-if="typex">
                        المسائلة: {{ typex }}
                    </h5>
                </div>
                <hr>
            </div>
            <div v-html="displayHtml"></div>
        </div>
        <div class="card-footer" v-if="ask.allow_teacher_reply && !ask.teacher_reply">
            <p>تقديم الافادة</p>
            <div class="form-group">
              <textarea class="form-control" v-model="reply" rows="3" placeholder="اكتب الافادة/الرد هنا..."></textarea>
            </div>
            <div class="form-group">
              <label>التوقيع (ارسم توقيعك بالماوس أو بالاصبع)</label>
              <div style="border: 2px solid #ccc; border-radius: 8px; background: #fff; position: relative; touch-action: none;">
                <canvas ref="sigCanvas" width="500" height="200" style="width: 100%; height: 200px; cursor: crosshair; display: block;"></canvas>
                <button class="btn btn-sm btn-outline-danger" style="position: absolute; top: 5px; left: 5px;" @click="clearSignature()">
                  <i class="fa fa-trash"></i> مسح
                </button>
              </div>
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="send()">
                    ارسال <i class="fa fa-arrow-left"></i>
                </button>
                <button class="btn btn-success" style="margin-right: 8px;" @click="print()">
                    <i class="fa fa-print"></i> طباعة
                </button>
            </div>
        </div>
        <div class="card-footer" v-else-if="ask.html">
            <div class="col-12 text-center g">
                <button class="btn btn-success" @click="print()">
                    <i class="fa fa-print"></i> طباعة
                </button>
            </div>
        </div>
        <div class="card-footer" v-if="ask.teacher_reply">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <p><strong>رد المعلم:</strong> {{ ask.teacher_reply }}</p>
                    <div v-if="ask.teacher_signature">
                        <strong>توقيع المعلم:</strong><br>
                        <img :src="ask.teacher_signature" style="max-width: 250px; border: 1px solid #eee; border-radius: 5px;">
                    </div>
                </div>
                <div class="col-12 col-lg-6" v-if="ask.admin_signature">
                    <strong>توقيع مدير المدرسة:</strong><br>
                    <img :src="ask.admin_signature" style="max-width: 250px; border: 1px solid #eee; border-radius: 5px;">
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 text-center text-muted">
        الخدمة مقدمة من <a href="https://tahdir.net">التحضير الذكي</a>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        typex(){
            var t = this.ask.type;
            if(!t) return '';
            if(t == 'late') return 'مسائلة تأخر';
            if(t == 'out_early') return 'مسائلة انصراف';
            if(t == 'ghiab') return 'مسائلة غياب';
            if(t == 'dis') return 'قرار حسم غياب';
            if(t == 'latedis') return 'قرار حسم مجموع ساعات تأخر وخروج مبكر';
            if(t && t.toString().indexOf('other') === 0){
                var types = [
                    'عدم تواجد داخل الفصل',
                    'خروجك من الحصة قبل انتهاء الوقت',
                    'عدم تحضير الدروس',
                    'عدم المناوبة في الفسحة',
                    'عدم المناوبة في الممرات',
                    'عدم المناوبة في نهاية الدوام',
                    'عدم الحضور لحصص الانتظار'
                ];
                var idx = parseInt(t.toString().split('other-')[1]) - 1;
                return types[idx] || '';
            }
            return '';
        },
        displayHtml(){
            var html = this.ask.html || '';
            var sigImg = function(src){ return '<img src="' + src + '" style="max-width: 150px; max-height: 60px; vertical-align: middle;">'; };
            if(this.ask.admin_signature){
                html = html.replaceAll('{admin_sig}', sigImg(this.ask.admin_signature));
            }else{
                html = html.replaceAll('{admin_sig}', '');
            }
            if(this.ask.teacher_signature){
                html = html.replaceAll('{teacher_sig}', sigImg(this.ask.teacher_signature));
            }else{
                html = html.replaceAll('{teacher_sig}', '');
            }
            return html;
        }
    },
    data(){
        return {
            ask: {},
            reply: "",
            isDrawing: false,
            ctx: null
        }
    },
    created(){
        var g = this;
        $.post(api + '/general/teacher-ask', {
            id: window.location.href.split("ask/")[1]
        }).then(function(r){
            g.step = 1
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                g.ask = r.response;
                if(r.response.allow_teacher_reply && !r.response.teacher_reply){
                    g.$nextTick(function(){
                        g.initSignature();
                    })
                }
            }
        }).fail(function(){
            alert("حدث خطأ في الاتصال", 200);
        })
    },
    methods: {
        initSignature(){
            var g = this;
            var canvas = g.$refs.sigCanvas;
            if(!canvas) return;
            g.ctx = canvas.getContext('2d');
            g.ctx.strokeStyle = '#000';
            g.ctx.lineWidth = 2;
            g.ctx.lineCap = 'round';
            g.ctx.lineJoin = 'round';

            function getPos(e){
                var rect = canvas.getBoundingClientRect();
                var scaleX = canvas.width / rect.width;
                var scaleY = canvas.height / rect.height;
                if(e.touches && e.touches.length > 0){
                    return {
                        x: (e.touches[0].clientX - rect.left) * scaleX,
                        y: (e.touches[0].clientY - rect.top) * scaleY
                    }
                }
                return {
                    x: (e.clientX - rect.left) * scaleX,
                    y: (e.clientY - rect.top) * scaleY
                }
            }

            function startDraw(e){
                e.preventDefault();
                g.isDrawing = true;
                var pos = getPos(e);
                g.ctx.beginPath();
                g.ctx.moveTo(pos.x, pos.y);
            }
            function draw(e){
                if(!g.isDrawing) return;
                e.preventDefault();
                var pos = getPos(e);
                g.ctx.lineTo(pos.x, pos.y);
                g.ctx.stroke();
            }
            function stopDraw(e){
                if(g.isDrawing){
                    e.preventDefault();
                    g.isDrawing = false;
                }
            }

            canvas.addEventListener('mousedown', startDraw);
            canvas.addEventListener('mousemove', draw);
            canvas.addEventListener('mouseup', stopDraw);
            canvas.addEventListener('mouseleave', stopDraw);
            canvas.addEventListener('touchstart', startDraw);
            canvas.addEventListener('touchmove', draw);
            canvas.addEventListener('touchend', stopDraw);
        },
        clearSignature(){
            var canvas = this.$refs.sigCanvas;
            if(canvas && this.ctx){
                this.ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        },
        getSignatureData(){
            var canvas = this.$refs.sigCanvas;
            if(!canvas) return null;
            var ctx = canvas.getContext('2d');
            var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            for(var i = 3; i < pixels.length; i += 4){
                if(pixels[i] > 0) return canvas.toDataURL('image/png');
            }
            return null;
        },
        print(){
            var g = this;
            var printWindow = window.open("", "");
            printWindow.document.write(
                "<html lang='ar'><head dir='rtl'><title>tahdir.net</title>"
            );
            printWindow.document.write('<style type="text/css">');
            printWindow.document.write(`
                @page { size: A4; margin: 8mm; }
                * { box-sizing: border-box; }
                html, body { margin: 0; padding: 0; }
                body {
                    font-family: Arial;
                    font-size: 9pt;
                    direction: rtl;
                    line-height: 1.25;
                }
                h1, h2, h3, h4, h5, h6 { margin: 2px 0; line-height: 1.25; }
                h1 { font-size: 12pt; }
                h2 { font-size: 11pt; }
                h3 { font-size: 10pt; }
                h4, h5 { font-size: 9pt; }
                p { margin: 2px 0; }
                br { line-height: 0.6; }
                ul, ol { margin: 2px 0; padding-right: 18px; }
                li { margin: 1px 0; }
                table {
                    border: 1px solid #ccc;
                    border-collapse: collapse;
                    width: 100%;
                    margin: 2px 0;
                }
                table th {
                    background-color: #F7F7F7;
                    color: #333;
                    font-weight: bold;
                    background: #D6EFD8;
                    padding: 2px 4px;
                }
                table td {
                    padding: 2px 4px;
                    background: #E7F0DC;
                }
                table th, table td { border: 1px solid #ccc; }
                img { max-height: 55px; }
                .print-header { width: 100%; margin-bottom: 4px; }
                .print-header > div { display: inline-block; vertical-align: middle; text-align: center; }
                .print-header hr { margin: 4px 0; }
            `);
            printWindow.document.write("</style></head>");
            printWindow.document.write(`
                <body>
                    <div class='print-header'>
                        <div style='width: 32%;'>
                            <h5>
                                المملكة العربية السعودية
                                <br>
                                ${g.ask.ministry_name || window.ministry_name}
                                <br>
                                ${g.ask.school_name || ''}
                            </h5>
                        </div>
                        <div style='width: 32%;'>
                            <img style="width: 110px;" src="${g.ask.ministry_logo || window.ministry_logo}">
                        </div>
                        <div style='width: 32%;'>
                            ${g.typex ? `<h5>المسائلة: ${g.typex}</h5>` : ''}
                        </div>
                        <hr>
                    </div>
                    ${g.displayHtml}
                </body>
            `);
            printWindow.document.close();
            setTimeout(function(){ printWindow.print(); }, 1000);
        },
        send(){
          var g = this;
          var signature = g.getSignatureData();
            $.post(api + '/general/teacher-ask-send', {
                id: window.location.href.split("ask/")[1],
                reply: g.reply,
                signature: signature
            }).then(function(r){
                g.step = 1
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    alert("تم الارسال بنجاح", 100)
                    location.reload();
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200);
            })
        }
    }
}
</script>

<style>

</style>
